import { useNavigate } from "react-router-dom";

const AgencyPublicBanner = ({
  agency,
  className = "",
  isOnClickNavigate = false,
}) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        if (isOnClickNavigate) {
          navigate(`/search/agency/${agency?.id}`);
        }
      }}
      className={`bg-gradient-to-r from-[#1A212F] to-[#374DF5] flex items-start md:items-center rounded-xl text-white relative overflow-hidden h-[160px] md:h-[200px] cursor-pointer ${className}`}
    >
      {/* Main Content */}
      <div className="w-full mx-auto px-4 md:px-14 py-4 md:py-8 flex items-start md:items-center relative z-10">
        <div className="flex flex-col md:flex-row gap-4 md:gap-8 items-start md:items-center justify-between w-full ">
          {/* Left Section - Image and Basic Info */}
          <div className="flex items-center gap-4 md:gap-6">
            {/* Agency Image */}
            <div className="w-[64px] h-[64px] md:w-[100px] md:h-[100px] rounded-lg overflow-hidden bg-gray-700 flex items-center justify-center">
              {agency?.profile_picture_url ? (
                <img
                  src={agency.profile_picture_url}
                  alt={agency.name}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full bg-gray-600 flex items-center justify-center">
                  <span className="text-gray-400 text-lg md:text-2xl font-bold">
                    {agency?.name?.charAt(0) || "A"}
                  </span>
                </div>
              )}
            </div>

            {/* Basic Info */}
            <div className="flex flex-col justify-center">
              <h1 className="text-2xl md:text-4xl font-bold mb-2 md:mb-3 text-white">
                {agency?.name || "Agency Name"}
              </h1>
            </div>
          </div>

          {/* Middle Section - Key Details Cards */}
          <div className="hidden md:flex flex-col gap-4 ml-auto">
            {/* Overall Ranking Card */}
            <div className="flex items-center gap-4">
              <div className="bg-white backdrop-blur-sm rounded-xl px-6 py-4 min-w-[140px]">
                <div className="flex items-center gap-2">
                  <span className="text-sm text-[#1A212F]">
                    Overall Ranking:
                  </span>
                  <span className="text-sm font-bold text-[#1A212F]">
                    {agency?.overall_ranking || "N/A"}
                  </span>
                </div>
              </div>

              {/* License Card. D-A follow-up (Marin, 2026-08-04): the value
                  is the caller's neutral self-declaration wording — the old
                  hardcoded "FIFA Licensed" fallback claimed a FIFA licence
                  for ANY agency whose payload lacked the field. No value ->
                  no card (hero precedent: absence renders nothing, no
                  "Not Licensed" line). */}
              {agency?.license && (
                <div className="bg-white backdrop-blur-sm rounded-xl px-6 py-4 min-w-[140px]">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-[#1A212F]">License:</span>
                    <span className="text-sm font-bold text-[#1A212F]">
                      {agency.license}
                    </span>
                  </div>
                </div>
              )}

              {/* TP Points Card */}
              <div className="bg-white backdrop-blur-sm rounded-xl px-6 py-4 min-w-[140px]">
                <div className="flex items-center gap-2">
                  <span className="text-sm text-[#1A212F]">TP Points:</span>
                  <span className="text-sm font-bold text-[#1A212F]">
                    {/* T053: the ONE authoritative figure is the agency
                        wallet balance the payload carries. A hardcoded
                        "15,000" used to stand in whenever it was missing —
                        an invented number under a factual label. Same
                        honest "-" fallback AgentHeroBanner already uses. */}
                    {typeof agency?.tp_points === "number"
                      ? agency.tp_points.toLocaleString()
                      : "-"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile Summary Chips */}
          <div className="md:hidden mt-3 flex flex-wrap gap-2">
            <div className="bg-white/90 text-[#1A212F] rounded-md px-3 py-1 text-xs">
              Rank: <span className="font-semibold">{agency?.overall_ranking || "N/A"}</span>
            </div>
            {/* Same rule as the desktop card: no value, no chip. */}
            {agency?.license && (
              <div className="bg-white/90 text-[#1A212F] rounded-md px-3 py-1 text-xs">
                License: <span className="font-semibold">{agency.license}</span>
              </div>
            )}
            <div className="bg-white/90 text-[#1A212F] rounded-md px-3 py-1 text-xs">
              TP:{" "}
              <span className="font-semibold">
                {typeof agency?.tp_points === "number"
                  ? agency.tp_points.toLocaleString()
                  : "-"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Country Flag - Bottom Right */}
      <div className="absolute right-3 bottom-3 md:right-6 md:bottom-6 flex items-center gap-3">
        {agency?.country ? (
          <img
            src={`https://flagcdn.com/${agency.country
              .toLowerCase()
              .substring(0, 2)}.svg`}
            alt={agency.country}
            className="h-4 w-6 md:h-6 md:w-8 rounded-sm"
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

export default AgencyPublicBanner;
